import { withTheme } from "@mui/styles";
import SignupStore from "./SignupStore";
import SignupContainer from "./SignupContainer";

export default SignupStore(withTheme(SignupContainer));